import { initialFlightObj } from "redux/filters/initialState";
import { ISearchForm } from "./searchForm.interfaces";

export const initialSearchForm: ISearchForm = {
  searchRequestId: null,
  topLevelDomain: "",
  utm_source: null,
  utm_campaign: null,
  utm_medium: null,
  utm_content: null,
  mktPortal: null,
  fareId: null,
  hmac: null,
  timestampInSeconds: null,
  totalPrice: null,
  adultPrice: null,
  childPrice: null,
  infantPrice: null,
  clickId: null,
  gdssource: false,
  gclsrc: null,
  airlines: null,
  metaStorageTimeout: new Date(0),
  isDirectBooking: false,
  passengers: { adults: 1, children: 0, infants: 0 },
  cabinClass: "ECONOMY",
  flights: [initialFlightObj, initialFlightObj],
  flexibleSearch: 0,
  tripType: "RETURN",
  isValid: false,
};
